import React from 'react';
import {
  QUOTATION_PAGE_DIMENSIONS,
  buildQuotationPrintLayoutCss,
  buildQuotationImageExportCss,
} from '../quotationLayoutUtils';

export function getQuotationPageStyle(pageDims, screenPreviewBoost) {
  return {
    width: '100%',
    maxWidth: `${pageDims.width}mm`,
    minHeight: screenPreviewBoost ? 'auto' : `${pageDims.height}mm`,
    margin: '0 auto',
    background: 'white',
    boxSizing: 'border-box',
    padding: '14px',
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'visible',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    borderRadius: '6px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
  };
}

export default function QuotationBillShell({
  children,
  pageSize = 'a4',
  orientation = 'portrait',
  screenPreviewBoost = false,
  sparseLayout = false,
}) {
  const pageDims = QUOTATION_PAGE_DIMENSIONS[pageSize]?.[orientation] || QUOTATION_PAGE_DIMENSIONS.a4.portrait;
  const pageStyle = getQuotationPageStyle(pageDims, screenPreviewBoost);
  const boostClass = screenPreviewBoost ? ' quotation-screen-preview-boost' : '';
  const sparseClass = sparseLayout ? ' quotation-sparse-items' : '';

  return (
    <div
      id="quotation-template"
      style={pageStyle}
      className={`text-sm print:p-0 print:shadow-none print:border-0 relative${boostClass}${sparseClass}`}
    >
      <div className="quotation-print-inner">{children}</div>

      <style>{`
        @media screen {
          #quotation-template.quotation-screen-preview-boost {
            min-height: auto !important;
          }
          ${buildQuotationPrintLayoutCss('#quotation-template.invoice-pdf-export', pageDims)}
          ${buildQuotationImageExportCss('#quotation-template.invoice-image-export')}
        }
        @media print {
          ${buildQuotationPrintLayoutCss('#quotation-template', pageDims)}
        }
      `}</style>
    </div>
  );
}
